import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "user-management roba-container flex" }
const _hoisted_2 = { class: "user-management__filters flex flex-column mr-2" }
const _hoisted_3 = { class: "white mb-2 pa-2" }
const _hoisted_4 = { class: "mb-05" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["checked", "onChange"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "white pa-2" }
const _hoisted_9 = ["checked", "onChange"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_users = _resolveComponent("users")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('COMMON.FILTERS')), 1),
        _createElementVNode("div", {
          class: "clear-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAllFilters && _ctx.clearAllFilters(...args))),
          disabled: _ctx.userRoleFilter.length === 0 && _ctx.portalStatusFilter.length === 0
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_ALL_FILTERS')), 9, _hoisted_5),
        _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mt mb" }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("b", null, "User type", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoles, (role) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "filter-checkbox mt",
            key: role.key
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.userRoleFilter.includes(role.value),
              onChange: ($event: any) => (_ctx.toggleUserRole(role.value, $event))
            }, null, 40, _hoisted_6),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-checkbox__box" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`ENUM.USER_ROLE.${role.key}`)), 1)
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "clear-button mt",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearUserRoleFilter && _ctx.clearUserRoleFilter(...args))),
          disabled: _ctx.userRoleFilter.length === 0
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_FILTERS')), 9, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[7] || (_cache[7] = _createElementVNode("b", null, "Status portal", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portalStatus, (status) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "filter-checkbox mt",
            key: status.key
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.portalStatusFilter.includes(status.value),
              onChange: ($event: any) => (_ctx.togglePortalStatus(status.value, $event))
            }, null, 40, _hoisted_9),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "filter-checkbox__box" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`ENUM.PORTAL_STATUS.${status.key}`)), 1)
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "clear-button mt",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearPortalStatusFilter && _ctx.clearPortalStatusFilter(...args))),
          disabled: _ctx.portalStatusFilter.length === 0
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_FILTERS')), 9, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_users, {
        userRoleFilter: _ctx.userRoleFilter,
        portalStatusFilter: _ctx.portalStatusFilter,
        "show-text": false
      }, null, 8, ["userRoleFilter", "portalStatusFilter"])
    ])
  ]))
}